import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import frontComponentFilters from "front-component/Filters";
import Configuration from "front-component/Configuration";
import filters from "./filters";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/fr";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Component from "vue-class-component";
import moment from "moment";

library.add(fas);

// Register the router hooks (Navigation guards) before components initialization
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteUpdate",
  "beforeRouteLeave",
]);

moment.locale("fr");
const verTime = moment().format("YYYYMMDDHH");
Configuration.load(location.origin + `/configuration.json?v=${verTime}`).then(() => {
  Vue.config.productionTip = false;
  Vue.use(frontComponentFilters);
  Vue.use(filters);
  Vue.use(ElementUI, { locale });
  Vue.component("fa-icon", FontAwesomeIcon);

  new Vue({
    router,
    store,
    render: (h: any) => h(App),
  }).$mount("#app");

  store.getters.loadTranslations("ptf");
});
